import React, { useState, useRef, useEffect } from "react";
import {
  MenuItem,
  CircularProgress,
  IconButton,
  Menu,
  Grid,
  Dialog,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import dayjs, { Dayjs } from "dayjs";
import Calendar from "../../../components/calendar/Calender";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";

const CustomerDetails = () => {
  const [summaryGiftCard, setSummaryGiftCard] = useState<any>([]);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | null>(
    dayjs().add(-7, "days"),
  );

  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(dayjs());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [circle, setCircle] = useState<Boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      const startDateParam = selectedStartDate.format("YYYY-MM-DD");
      const endDateParam = selectedEndDate.add(1, "days").format("YYYY-MM-DD");
      setSummaryGiftCard(null);
      setCircle(true);
      GetcustomerDetails(startDateParam || "", endDateParam || "");
    }
  }, [selectedStartDate, selectedEndDate]);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const columnDefs: ColDef[] = [
    {
      field: "registerationDate",
      headerName: "Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "userId",
      headerName: "UserId",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "userStatus",
      headerName: "User Status",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "email",
      headerName: "Email",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "firstName",
      headerName: "FirstName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "lastName",
      headerName: "LastName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "emailConfirmed",
      headerName: "EmailConfirmed",
      filter: true,
      resizable: true,
      sortable: true,
      cellDataType: "text",
    },
  ];

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
    handleMenuClose();
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedStartDate(date);
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedEndDate(date);
    }
  };

  const GetcustomerDetails = async (startDate: string, endDate: string) => {
    toast.dismiss();
    await sendCreditAxios
      .post(`/CRMUser/GetActiveUserDetailsAsync`, {
        FromDate: startDate,
        toDate: endDate,
      })
      .then((response: any) => {
        const responseData = response.data?.payload;

        if (responseData?.length > 0) {
          setSummaryGiftCard(responseData);
          setCircle(false);
        } else {
          toast.info("No record Found");
          setCircle(false);
        }
      })
      .catch((error) => {
        setCircle(false);
      });
  };

  const onRowClicked = (event: { data: any }) => {
    const rowData = event.data;
    setSelectedRowData(rowData);
    setOpen(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div>
        <h2 className="heading">Customer Details</h2>
        {selectedEndDate &&
          selectedStartDate &&
          Math.floor(selectedEndDate.diff(selectedStartDate, "day", true)) ===
            7 && <span className="small-text">Last 7 Days</span>}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <button
            className="small-btn"
            style={{ visibility: summaryGiftCard ? "visible" : "hidden" }}
            onClick={() => {
              if (summaryGiftCard) {
                exportGridDataAsCSV();
              }
            }}
          >
            Export as CSV
          </button>
        </div>
        <IconButton
          onClick={(e: any) => {
            handleMenuClick(e);
          }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={toggleCalendar}></MenuItem>
          {selectedStartDate && selectedEndDate && (
            <Calendar
              selectedStartDate={selectedStartDate}
              selectedEndDate={selectedEndDate}
              onStartDateChange={handleStartDateChange}
              onEndDateChange={handleEndDateChange}
            />
          )}
        </Menu>
      </div>

      {circle && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}
      {summaryGiftCard && (
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "425px", overflowY: "auto" }}
        >
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={50}
            pagination={true}
            rowData={summaryGiftCard}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onRowClicked={onRowClicked}
          ></AgGridReact>
        </div>
      )}

      {selectedRowData != null && (
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="dialogBox"
        >
          <h2
            style={{
              fontWeight: "bold",
              margin: "10px 0",
              paddingLeft: "10px",
            }}
          >
            Details
          </h2>
          <Grid
            container
            spacing={2}
            style={{
              margin: "3px 0 20px 0",
              width: "100%",
              padding: "0px 10px 0px 10px",
            }}
          >
            <Grid item xs={12} style={{ padding: "0" }}>
              <Grid container>
                <Grid item xs={4}>
                  <p className="tableHeader">Date</p>
                </Grid>
                <Grid item xs={8} md={8}>
                  <p className="tableData">
                    {selectedRowData.registerationDate}
                  </p>
                </Grid>

                <Grid item xs={4}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    UserId
                  </p>
                </Grid>
                <Grid item xs={8} md={8}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.userId}
                  </p>
                </Grid>

                <Grid item xs={4}>
                  <p className="tableHeader">User Status </p>
                </Grid>
                <Grid item xs={8} md={8}>
                  <p className="tableData">{selectedRowData.userStatus}</p>
                </Grid>

                <Grid item xs={4}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Email
                  </p>
                </Grid>
                <Grid item xs={8} md={8}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.email}
                  </p>
                </Grid>

                <Grid item xs={4}>
                  <p className="tableHeader">First Name</p>
                </Grid>
                <Grid item xs={8} md={8}>
                  <p className="tableData">{selectedRowData.firstName}</p>
                </Grid>

                <Grid item xs={4}>
                  <p
                    className="tableHeader"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    Last Name
                  </p>
                </Grid>
                <Grid item xs={8} md={8}>
                  <p
                    className="tableData"
                    style={{ backgroundColor: "#f2eded" }}
                  >
                    {selectedRowData.lastName}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </motion.div>
  );
};

export default CustomerDetails;
